module.exports = __webpack_public_path__ + "img/position-inbox.8866630d.svg";